import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { login as apiLogin, logout as apiLogout } from '../api/auth';
import { extractErrorMessage } from '../api/client';
import type { LoginInput } from '../api/auth';
import { useAuthStore } from '../store/auth.store';

export function useAuth() {
  const navigate = useNavigate();
  const { user, token, isAuthenticated, setSession, clearSession } = useAuthStore();

  const login = useCallback(
    async (input: LoginInput) => {
      const payload = await apiLogin(input);
      setSession(payload);
      navigate('/dashboard');
    },
    [navigate, setSession],
  );

  const logout = useCallback(async () => {
    try {
      if (user?.guid) {
        await apiLogout(user.guid);
      }
    } catch (error) {
      // Локальный logout должен пройти даже если сервер недоступен.
      // eslint-disable-next-line no-console
      console.warn('[logout] server call failed', extractErrorMessage(error));
    } finally {
      clearSession();
      toast.success('Вы вышли из аккаунта');
      navigate('/login');
    }
  }, [user?.guid, clearSession, navigate]);

  return { user, token, isAuthenticated, login, logout, setSession };
}
